export function getCookie(name: string): string | undefined {
  if (typeof document === "undefined") {
    return undefined
  }

  try {
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
      const cookieValue = parts.pop()?.split(";").shift()
      return cookieValue !== undefined ? decodeURIComponent(cookieValue) : undefined
    }
  } catch (error) {
    console.error("Error reading cookie:", error)
  }
  return undefined
}

export function setCookie(name: string, value: string, days: number): void {
  if (typeof document === "undefined") {
    return
  }

  try {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    const expires = `expires=${date.toUTCString()}`
    const sanitizedValue = encodeURIComponent(value)
    document.cookie = `${name}=${sanitizedValue};${expires};path=/;Secure;SameSite=Strict`
  } catch (error) {
    console.error("Error setting cookie:", error)
  }
}

export function deleteCookie(name: string): void {
  if (typeof document === "undefined") {
    return
  }

  try {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;Secure;SameSite=Strict`
  } catch (error) {
    console.error("Error deleting cookie:", error)
  }
}

